import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=7620e074&scoped=true&"
import script from "./CButton.vue?vue&type=script&lang=js&"
export * from "./CButton.vue?vue&type=script&lang=js&"
import style0 from "./CButton.vue?vue&type=style&index=0&id=7620e074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620e074",
  null
  
)

export default component.exports